var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKe = function SvgKe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ccc2e5c-0148-46de-8293-09bcd81d2b69a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "12550754-f885-4c14-8a74-00865610efceb",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#12550754-f885-4c14-8a74-00865610efceb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 10h21v1H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006700",
    fillRule: "evenodd",
    d: "M0 11h21v4H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD0000",
    fillRule: "evenodd",
    d: "M0 5h21v5H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 4h21v1H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.414 5.914c.072 0 .5-.67.5-1.5 0-.828-.428-1.5-.5-1.5-.07 0-.5.672-.5 1.5 0 .83.43 1.5.5 1.5m-2.939-.439c-.05.05-.83-.12-1.414-.707-.585-.586-.757-1.364-.706-1.414.05-.05.828.12 1.414.707.586.586.757 1.364.707 1.415zm1.879 4.533c.05-.047.83.113 1.415.66.585.55.757 1.277.707 1.324s-.83-.113-1.416-.66c-.585-.55-.757-1.277-.706-1.324m-1.879 0c-.05-.047-.83.113-1.414.66-.585.55-.757 1.277-.706 1.324.05.047.828-.113 1.414-.66.586-.55.757-1.277.707-1.324z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD0000",
    fillRule: "evenodd",
    d: "M10.5 12c.357 0 2.5-2.015 2.5-4.5S10.857 3 10.5 3 8 5.015 8 7.5s2.143 4.5 2.5 4.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.5 9c.07 0 .5-.672.5-1.5S8.57 6 8.5 6 8 6.672 8 7.5 8.43 9 8.5 9m4 0c.07 0 .5-.672.5-1.5S12.57 6 12.5 6s-.5.672-.5 1.5.43 1.5.5 1.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 7.5c0-.828-.224-1.5-.5-1.5s-.5.672-.5 1.5.224 1.5.5 1.5.5-.672.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0ccc2e5c-0148-46de-8293-09bcd81d2b69a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgKe;